<template>
  <Transition name="alert-slide">
    <div v-if="show" class="alert-wrapper" :class="position">
      <div class="alert" :class="type">
        <span class="icon" v-html="icon"></span>
        <span class="message">{{ message }}</span>
      </div>
    </div>
  </Transition>
</template>

<script>
import { alertIcons } from '@/assets/icons/alertIcons'

export default {
  name: 'AlertComponent',
  computed: {
    show () {
      return this.$store.getters.getGlobalAlertState
    },
    message () {
      return this.$store.getters.getGlobalAlertMessage
    },
    type () {
      return this.$store.getters.getGlobalAlertType
    },
    position () {
      return this.$store.getters.getGlobalAlertPosition
    },
    duration () {
      return this.$store.getters.getGlobalAlertDuration
    },
    icon () {
      return alertIcons[this.type] || alertIcons.info
    }
  },
  watch: {
    show (val) {
      if (val) {
        setTimeout(() => {
          this.$store.commit('hideGlobalAlert')
        }, this.duration)
      }
    }
  }
}
</script>

<style scoped>
/* WRAPPER */
.alert-wrapper {
  position: fixed;
  top: 20px;
  z-index: 99999;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
}

.alert-wrapper.top-right {
  justify-content: flex-end;
  padding-right: 20px;
}

.alert-wrapper.top-left {
  justify-content: flex-start;
  padding-left: 20px;
}

/* ALERT BOX */
.alert {
  max-width: 550px;
  width: fit-content;
  padding: 18px 16px;
  border-radius: 10px;
  color: #fff;

  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-weight: 600;
  pointer-events: auto;
}

/* TYPE */
.alert.info { background: #465F97; }
.alert.success { background: #06951E; }
.alert.warning { background: #EB9A3F; }
.alert.danger { background: #EE3D22; }
.alert.dark { background: #393B4A; }


/* TRANSITION */
.alert-slide-enter-active,
.alert-slide-leave-active {
  transition: all 0.3s ease;
}
.alert-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.alert-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.message {
  line-height: 1.4;
  word-break: break-word;
  text-align: left;
}

/* ICON */
.icon {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.icon .alert-icon {
  width: 18px;
  height: 18px;
}
</style>
